import { render } from "./AddMpostBox.vue?vue&type=template&id=6d2ff895&ts=true"
import script from "./AddMpostBox.vue?vue&type=script&lang=ts"
export * from "./AddMpostBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__